import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'stagnant-cell',
  standalone: true,
  imports: [CommonModule],
  template: `
    <span class="cell-text" (click)="onCellClick(rowData)">
      {{ data }}
    </span>
  `,
  styles: [
    `
      .cell-text {
        font-family: var(--manrope);
        font-weight: 500;
        font-size: 16px;
        color: var(--brand-primary);
        cursor: pointer;
      }
    `,
  ],
})
export class StagnantCellComponent {
  @Input() data: any;
  @Input() rowData: any;
  @Input() type!: string;
  @Output() cellClick: EventEmitter<any> = new EventEmitter<any>();

  onCellClick(rowData: any) {
    this.cellClick.emit({ rowData, columnId: this.type, clicked: false });
  }
}
